import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ReportsRequestPage.RuleEmailSection', {
    invalidEmailsToast: 'The following invalid emails were not added:',
    invalidEmailsToastMore: '...and {count} more.',
    sendEmailsToTitle: 'Send report to',
    placeholder: 'Type emails with comma separation. Or paste multiple emails',
    addButton: 'Add these emails',
    noEmailsText: 'No emails have been added yet.',
    useInputAbove: 'Use the input above to add one or multiple emails',
});
